'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emojisList = require('./emojis-list');

var _emojisList2 = _interopRequireDefault(_emojisList);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var emojisPerPage = 50;

var EmojiPicker = function (_React$Component) {
  _inherits(EmojiPicker, _React$Component);

  function EmojiPicker() {
    _classCallCheck(this, EmojiPicker);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.state = {
      currentPage: 0,
      totalPage: Math.floor(_emojisList2["default"].length / emojisPerPage)
    };
    return _this;
  }

  EmojiPicker.prototype.pickEmoji = function pickEmoji(emoji) {
    if (this.props.onChange) {
      this.props.onChange(emoji);
    }
  };

  EmojiPicker.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state;
    var currentPage = _state.currentPage;
    var totalPage = _state.totalPage;

    var emojis = _emojisList2["default"].slice(currentPage * emojisPerPage, (currentPage + 1) * emojisPerPage).map(function (emoji) {
      var _classnames;

      var className = (0, _classnames4["default"])((_classnames = {}, _defineProperty(_classnames, 'emoji', true), _defineProperty(_classnames, 'emoji-' + emoji.shortCut, true), _classnames));
      return _react2["default"].createElement(
        'span',
        { className: className, onMouseDown: _this2.pickEmoji.bind(_this2, emoji) },
        _react2["default"].createElement('img', { src: '' + emoji.url, alt: '' })
      );
    });
    var paginations = [];

    var _loop = function _loop(i) {
      var _classnames2;

      var className = (0, _classnames4["default"])((_classnames2 = {}, _defineProperty(_classnames2, 'emoji-paginationIcon', true), _defineProperty(_classnames2, 'active', i === currentPage), _classnames2));
      paginations.push(_react2["default"].createElement('span', { className: className, onClick: function onClick() {
          return _this2.setState({ currentPage: i });
        } }));
    };

    for (var i = 0; i < totalPage; i++) {
      _loop(i);
    }
    return _react2["default"].createElement(
      'div',
      { className: 'emoji-picker-wrapper', onClick: function onClick(ev) {
          ev.stopPropagation();ev.nativeEvent.stopImmediatePropagation();
        } },
      emojis,
      _react2["default"].createElement(
        'div',
        { className: 'pagination-wrap' },
        paginations
      )
    );
  };

  return EmojiPicker;
}(_react2["default"].Component);

exports["default"] = EmojiPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-emoji@0.2.9@rc-editor-plugin-emoji/lib/EmojiPicker.js
// module id = 217
// module chunks = 0 1 2